<template>
  <div id="app">
    <!--<img src="./assets/logo.png">-->
    <router-view/>
  </div>
</template>

<script>
  export default {
    name: 'App'
  }
</script>

<style>
  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    margin-top: -10px;

   /* display: flex; !* 启用flexbox布局 *!
    flex-wrap: wrap; !* 允许子元素换行 *!
    justify-content: center; !* 横向居中对齐 *!
    align-items: center; !* 纵向居中对齐 *!
    gap: 100px; !* 设置子元素之间的间距 *!
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;*/
  }
</style>